export default __webpack_public_path__ + "static/media/Group 43.796dcb17.png";